import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

import { Icon } from '../iconTypes';

const IconCodeBlock = ({ className = '', color = '#979797', height = 16, title, width = 16 }: Icon) => (
    <AccessibleSVG
        className={`icon-code-block ${className}`}
        height={height}
        title={title}
        viewBox="0 0 16 16"
        width={width}
    >
        <path
            className="fill-color"
            d="M9.237 4.002c-.145.015-.268.12-.313.27L6.38 12.48c-.064.205.04.428.23.497.19.07.4-.042.463-.248l2.544-8.21c.042-.127.02-.268-.057-.373-.077-.106-.2-.162-.323-.148zm-4.534 1.37c-.056.003-.11.022-.16.054L.184 8.162c-.113.07-.183.2-.183.34s.07.27.182.34l4.362 2.735c.113.07.252.07.365 0 .112-.07.18-.198.18-.34 0-.14-.07-.268-.182-.338L1.085 8.504l3.823-2.4c.15-.09.223-.28.174-.457-.05-.177-.207-.293-.38-.277zm6.21.3c-.036.17.037.347.18.432l3.822 2.4-3.823 2.395c-.113.07-.183.198-.183.338s.068.27.18.34c.114.07.253.07.366 0l4.362-2.737c.112-.07.182-.2.182-.34s-.07-.268-.182-.338l-4.362-2.736c-.062-.04-.133-.06-.205-.055-.16.008-.3.132-.336.302z"
            fill={color}
            fillRule="evenodd"
        />
    </AccessibleSVG>
);

export default IconCodeBlock;
